import type { ReactNode } from "react";

import "./Pill.css";

type Tone =
  | "default" | "muted" | "info" | "success" | "warning" | "danger"
  | "ativa" | "alerta" | "pausada" | "diag" | "onb" | "inad" | "arq";

const TONE_CLASS: Record<Tone, string> = {
  default: "st-pill",
  muted: "st-pill st-pausada",
  info: "st-pill st-diag",
  success: "st-pill st-ativa",
  warning: "st-pill st-inad",
  danger: "st-pill st-alerta",
  ativa: "st-pill st-ativa",
  alerta: "st-pill st-alerta",
  pausada: "st-pill st-pausada",
  diag: "st-pill st-diag",
  onb: "st-pill st-onb",
  inad: "st-pill st-inad",
  arq: "st-pill st-arq",
};

export function Pill({ tone = "default", children }: { tone?: Tone; children: ReactNode }) {
  return <span className={TONE_CLASS[tone]}>{children}</span>;
}
